var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 1L2.83325 7.90909V18.2727C2.83325 27.8591 9.23325 36.8236 17.8333 39C26.4333 36.8236 32.8333 27.8591 32.8333 18.2727V7.90909L17.8333 1ZM17.8333 11.3636C20.1666 11.3636 22.4999 13.2636 22.4999 15.6818V18.2727C23.4999 18.2727 24.4999 19.3091 24.4999 20.5182V26.5636C24.4999 27.6 23.4999 28.6364 22.3333 28.6364H13.1666C12.1666 28.6364 11.1666 27.6 11.1666 26.3909V20.3455C11.1666 19.3091 12.1666 18.2727 13.1666 18.2727V15.6818C13.1666 13.2636 15.4999 11.3636 17.8333 11.3636ZM17.8333 13.4364C16.4999 13.4364 15.3333 14.3 15.3333 15.6818V18.2727H20.3333V15.6818C20.3333 14.3 19.1666 13.4364 17.8333 13.4364Z",
    fill: "#416661"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSecurity);
export default __webpack_public_path__ + "static/media/home-security.e7bd4962185bae00518f7611e872c41c.svg";
export { ForwardRef as ReactComponent };